module.exports = __webpack_public_path__ + "img/dianliang2.ee182093.png";